import React from "react";
import styles from "./BusinessLimit.module.scss";
import { Divider } from "@material-ui/core";
import { InputLabel, TextField } from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "../../formUI/Select";
import { useDispatch } from "react-redux";
import axios from "axios";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import {
	openLoader,
	closeLoader,
} from "../../../redux/actions/loader/loaderActions";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { makeStyles } from "@material-ui/core";
import { closeModal } from "../../../redux/actions/modal/modalActions";

const useStyles = makeStyles({
	root: {
		"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"& .MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-input.MuiOutlinedInput-input":
			{
				textAlign: "center",
				padding: "8.1px 14px",
			},
	},
	select: {
		"& .MuiOutlinedInput-root": {
			color: "#414141",
			fontFamily: "Avenir",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "16px",
			textTransform: "capitalize",
		},
		"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			outline: "none",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
			backgroundColor: "#ffffff",
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: "#E0E0E0",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #E0E0E0",
		},
	},
});

function BusinessLimit({
	id,
	content,
	identifier,
	setBearer,
}: {
	id: number | undefined;
	content?: any;
	identifier: string;
	setBearer: React.Dispatch<React.SetStateAction<boolean>>;
}) {
	const classes = useStyles();
	const dispatch = useDispatch();

	const validate = Yup.object({
		transactionType: Yup.string().required("Required"),
		authOption: Yup.string(),
		paymentMethod: Yup.string().required("Required"),
		transactionLocale: Yup.string().required("Required"),
		minLimit: Yup.string().required("Required"),
		maxLimit: Yup.string().required("Required"),
		cumulativeTransactionLimit: Yup.string().required("Required"),
		otp: Yup.string().required("Required"),
	});

	const authOptions = [
		{
			name: "3ds",
			label: "3ds",
		},
		{
			name: "noauth",
			label: "No Auth",
		},
		{
			name: "pin",
			label: "Pin",
		},
		{
			name: "bank_transfer",
			label: "Bank Transfer",
		},
		{
			name: "ALL",
			label: "All",
		},
	];

	const transactionOption = [
		{
			name: "collection",
			label: "Collection",
		},
		{
			name: "payout",
			label: "Payout",
		},
	];

	const paymentMethodOption = [
		{
			name: "card",
			label: "Card",
		},
		{
			name: "qr",
			label: "QR",
		},
		{
			name: "ussd",
			label: "USSD",
		},
		{
			name: "account",
			label: "Account",
		},
		{
			name: "momo",
			label: "Momo",
		},
		{
			name: "enaira",
			label: "E-Naira",
		},
		{
			name: "phone",
			label: "Phone",
		},
	];

	const transactionLocaleOption = [
		{
			name: "local",
			label: "Local",
		},
		{
			name: "international",
			label: "International",
		},
	];

	const INITIAL_VALUES = {
		transactionType: content ? content?.transactiontype : "",
		authOption: content ? content?.auth : "",
		paymentMethod: content ? content?.payment : "",
		transactionLocale: content ? content?.transactionlocale : "",
		minLimit: content ? content?.min?.split(" ")[1] : "",
		maxLimit: content ? content?.max?.split(" ")[1] : "",
		cumulativeTransactionLimit: content ? content?.limit : "",
		otp: "",
	};

	return (
		<div className={styles.generalFourReuse}>
			<h3 className={styles.generalh3}>
				{identifier === "Edit" ? "View settings" : "Add Limit"}
			</h3>
			<Divider />

			<div className={styles.selectinput}>
				<Formik
					initialValues={INITIAL_VALUES}
					validationSchema={validate}
					onSubmit={(values) => {
						dispatch(openLoader());

						const newObject =
							identifier === "Edit"
								? {
										...values,
										currency: "NGN",
										limitId: content?.limitId,
								  }
								: {
										...values,
										currency: "NGN",
								  };

						axios
							.post(`v1/business/${id}/limit`, newObject)
							.then((res: any) => {
								setBearer(true);
								dispatch(
									openToastAndSetContent({
										toastContent: res?.data?.message,
										toastType: "success",
									})
								);
								dispatch(closeLoader());
								dispatch(closeModal());
							})
							.catch((err) => {
								dispatch(closeLoader());
								dispatch(
									openToastAndSetContent({
										toastContent:
											err.response?.data?.message ||
											err?.data?.message ||
											err?.message ||
											err,
										toastType: "error",
									})
								);
							});
					}}
				>
					{(props) => (
						<Form>
							<InputLabel>
								<span className={styles.span}>Transaction type</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="transactionType">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="transactionType"
								size="small"
								options={transactionOption}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>Auth options</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="authOption">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="authOption"
								size="small"
								options={authOptions}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>Payment method</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="paymentMethod">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="paymentMethod"
								size="small"
								options={paymentMethodOption}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>
							<InputLabel>
								<span className={styles.span}>Transaction locale</span>
							</InputLabel>
							<Field
								as={Select}
								helperText={
									<ErrorMessage name="transactionLocale">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="transactionLocale"
								size="small"
								options={transactionLocaleOption}
								className={classes.select}
								// fullWidth
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>Min limit</span>
							</InputLabel>
							<Field
								as={TextField}
								helperText={
									<ErrorMessage name="minLimit">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="minLimit"
								variant="outlined"
								margin="normal"
								type="text"
								size="small"
								fullWidth
								className={classes.select}
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>Max limit</span>
							</InputLabel>
							<Field
								as={TextField}
								helperText={
									<ErrorMessage name="maxLimit">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="maxLimit"
								variant="outlined"
								margin="normal"
								type="text"
								size="small"
								fullWidth
								className={classes.select}
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							<InputLabel>
								<span className={styles.span}>
									Cummulative transaction limit
								</span>
							</InputLabel>
							<Field
								as={TextField}
								helperText={
									<ErrorMessage name="cumulativeTransactionLimit">
										{(msg) => <span style={{ color: "red" }}>{msg}</span>}
									</ErrorMessage>
								}
								name="cumulativeTransactionLimit"
								variant="outlined"
								margin="normal"
								type="text"
								size="small"
								fullWidth
								className={classes.select}
								style={{
									marginTop: "8px",
									marginBottom: "22px",
								}}
							/>

							{identifier === "Edit" ? null : (
								<>
									<InputLabel>
										<span className={styles.span}>OTP</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="otp">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										InputLabelProps={{
											style: { fontSize: "0.8em" },
										}}
										label="Get OTP from Google Authenticator App"
										name="otp"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
										}}
									/>

									<InputLabel>
										<div style={{ display: "flex", alignItems: "center" }}>
											<InfoRoundedIcon />
											<p className={styles.info}>
												If you have not set up your 2FA, kindly{" "}
												<a
													style={{ color: "blue" }}
													href={`/account`}
													target="_blank"
												>
													click here
												</a>
											</p>
										</div>
									</InputLabel>

									<button
										style={{
											backgroundColor: "#27AE60",
											fontFamily: "Avenir",
											fontStyle: "normal",
											fontWeight: "bold",
											fontSize: "16px",
											lineHeight: "19px",
											textAlign: "center",
											border: "none",
											outline: "none",
											width: "100%",
											color: "#FFFFFF",
											padding: "13.39px 0",
											borderRadius: "20px",
											marginTop: "30px",
											cursor: "pointer",
										}}
										type="submit"
									>
										Submit
									</button>
								</>
							)}
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
}

export default BusinessLimit;
